import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["alerta"]

  connect() {
    // País/Estado readonly; Cidade preenche os dois.
    setTimeout(() => this._setupEnderecoCascade(), 300)

    // Estrangeiro: alterna CPF <-> Passaporte.
    this._setupDocToggle()

    const form = this._form()
    if (form) {
      // CEP preenche campos de ID (cidade_id, estado_id, pais_id) via fetch async.
      // Após cep:preenchido todos os lookups de ID terminaram — revalida tudo.
      form.addEventListener("cep:preenchido", () => {
        setTimeout(() => this._revalidarTodos(), 150)
      })
    }
  }

  _revalidarTodos() {
    const form = this._form()
    if (form) form.dispatchEvent(new Event("form-validation:revalidate"))
  }

  _form() {
    if (this.element.matches("form")) return this.element

    return this.element.querySelector("form") || this.element.closest("form")
  }

  // ===== Endereço: País/Estado readonly, Cidade preenche os dois ============

  _setupEnderecoCascade() {
    const form     = this.element
    const cidadeEl = form.querySelector('select[name$="[cidade_id]"]')
    const estadoEl = form.querySelector('select[name$="[estado_id]"]')
    const paisEl   = form.querySelector('select[name$="[pais_id]"]')
    if (!cidadeEl) return

    // País e Estado: readonly (TomSelect lock — não edita, mas submete valor).
    this._lockSelect(estadoEl)
    this._lockSelect(paisEl)

    cidadeEl.addEventListener("remote-select:changed", (e) => {
      const opt = e.detail && e.detail.option
      if (!opt) return

      if (opt.estado_id) this._setSelect(estadoEl, opt.estado_id, opt.estado_text)
      if (opt.pais_id)   this._setSelect(paisEl, opt.pais_id, opt.pais_text)

      setTimeout(() => this._revalidarTodos(), 50)
    })

    // Revalida (verde) os valores já preenchidos na edição.
    this._revalidarTodos()
  }

  _remoteCtrl(el) {
    if (!el) return null
    return this.application.getControllerForElementAndIdentifier(el, "remote-select")
  }

  _lockSelect(el) {
    const ctrl = this._remoteCtrl(el)
    if (ctrl && ctrl.tomselect) ctrl.tomselect.lock()
  }

  _setSelect(el, id, text) {
    const ctrl = this._remoteCtrl(el)
    if (!ctrl || !ctrl.tomselect) return

    ctrl.tomselect.unlock()
    ctrl.selectItem({ id: id, label: text })
    ctrl.tomselect.lock()
  }

  // ===== Estrangeiro: CPF <-> Passaporte =====================================

  _setupDocToggle() {
    const form = this.element
    const chk  = form.querySelector('input[type="checkbox"][name$="[estrangeiro]"]')
    if (!chk) return

    const cpf = form.querySelector('input[name$="[cpf]"]:not([type="hidden"])')
    if (!cpf) return

    const label = form.querySelector(`label[for="${cpf.id}"]`)

    // textContent apagaria o <span> do asterisco de obrigatório — troca só o texto.
    const asterisco = label?.querySelector("span")
    const setLabel = (texto) => {
      if (!label) return
      label.textContent = texto
      if (asterisco) label.appendChild(asterisco)
    }

    const aplicar = (limpar) => {
      const estr = chk.checked
      this._cpfMascara(cpf, !estr)            // estrangeiro => sem máscara
      setLabel(estr ? "Passaporte / Documento" : "CPF")
      if (limpar) cpf.value = ""
      this._revalidarTodos()
    }

    chk.addEventListener("change", () => aplicar(true))
    aplicar(false)
    // cpf-field pode conectar depois e remascarar — reaplica o estado.
    setTimeout(() => aplicar(false), 400)
  }

  // Liga/desliga a máscara de CPF. Desligar = remove o controller cpf-field e
  // suas actions (mask/bloqueio de letras). Guarda os originais p/ religar.
  _cpfMascara(cpf, ligada) {
    if (ligada) {
      if (cpf.dataset.cpfCtrlOrig !== undefined) {
        cpf.setAttribute("data-controller", cpf.dataset.cpfCtrlOrig)
        delete cpf.dataset.cpfCtrlOrig
      }
      if (cpf.dataset.cpfActionOrig !== undefined) {
        cpf.setAttribute("data-action", cpf.dataset.cpfActionOrig)
        delete cpf.dataset.cpfActionOrig
      }
      cpf.setAttribute("maxlength", "14")
      cpf.setAttribute("placeholder", "000.000.000-00")
      cpf.setAttribute("inputmode", "numeric")
    } else {
      if (cpf.dataset.cpfCtrlOrig === undefined) {
        cpf.dataset.cpfCtrlOrig = cpf.getAttribute("data-controller") || ""
      }
      if (cpf.dataset.cpfActionOrig === undefined) {
        cpf.dataset.cpfActionOrig = cpf.getAttribute("data-action") || ""
      }
      const ctrls = (cpf.getAttribute("data-controller") || "")
        .split(/\s+/).filter(c => c && c !== "cpf-field")
      cpf.setAttribute("data-controller", ctrls.join(" "))
      cpf.removeAttribute("data-action")
      cpf.removeAttribute("maxlength")
      cpf.setAttribute("placeholder", "Passaporte / Documento")
      cpf.removeAttribute("inputmode")
    }
  }

  apenasDigitosNumero(e) { this._soDig(e.target) }

  _soDig(el) {
    const pos   = el.selectionStart
    const antes = el.value
    el.value = antes.replace(/\D/g, "")
    if (el.value.length < antes.length) {
      el.setSelectionRange(Math.max(0, pos - 1), Math.max(0, pos - 1))
    }
  }
}
